export default __webpack_public_path__ + "static/media/INEX.992a27eb.png";